export * from "-!../../../../node_modules/babel-loader/lib/index.js!../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Concept.vue?vue&type=template&id=5915f70e"


//////////////////
// WEBPACK FOOTER
// ./src/pages/RoadSinisters/File/Concept.vue?vue&type=template&id=5915f70e
// module id = 1929
// module chunks = 31